var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooterMo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 19,
    viewBox: "0 0 250 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_6340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.929 0.265625H34.2054V18.7748H36.929V0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7455 8.14014L37.9918 9.52059L43.7455 10.901V8.14014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5968 0.265625H38.3035C42.1921 0.792241 44.7112 1.80969 46.5968 3.34863V0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6894 0.265625H50.9658V18.7748H53.6894V0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.747 18.7744L57.5524 7.7666L55.723 9.59698L61.7169 18.7744H64.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7614 0.265625C60.7614 0.265625 60.4957 2.75044 58.7277 6.59014L65.0486 0.265625H60.7665H60.7614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5968 15.6152C44.7112 17.1593 42.1921 18.2483 38.3035 18.7749H46.5968V15.6152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.143 0.265625H220.419V18.7748H223.143V0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.779 0.265625H223.981C229.177 0.741136 232.09 4.36116 232.09 9.50997C232.09 14.6588 229.208 18.2993 223.981 18.7748H225.779C230.899 18.7748 234.992 14.9502 234.992 9.50997C234.992 4.06972 231.14 0.265625 225.779 0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.616 0.265625H202.897V18.7697H205.616V0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.58 4.90825C215.58 0.756475 211.007 0.265625 209.545 0.265625H207.092C208.048 0.465033 212.693 0.976336 212.693 4.9287C212.693 9.82187 207.322 9.98037 207.322 9.98037C208.222 9.98037 209.065 10.4252 209.576 11.1666C212.56 15.5382 210.889 13.0891 214.435 18.7594H217.603L211.742 9.88834C213.413 9.51509 215.58 7.94028 215.58 4.91336V4.90825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.484 3.91145C239.484 2.22415 240.608 0.874312 242.621 0.173828C239.632 0.250523 237.21 2.09121 237.21 4.74487C237.21 11.9491 247.675 8.20128 247.675 14.3267C247.675 16.4026 246.551 18.0899 244.129 18.8722C247.496 18.7955 250 16.5611 250 13.3399C250 6.00268 239.484 9.62781 239.484 3.91656V3.91145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.029 4.00841V0.43458C248.007 0.449918 245.519 0.347663 244.359 0.173828C244.359 0.173828 247.379 0.858941 249.029 4.00841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.159 14.9248V18.6111L242.264 18.8719C239.198 17.9465 237.925 15.8962 237.159 14.9248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.503 17.2767L184.844 0.265625H182.085L178.503 17.2767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.974 0.265625L170.853 3.05222L168.155 17.517L172.105 7.00971L175.815 18.7748H178.641L172.831 0.265625H169.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.922 0.265625L165.498 18.7748H168.355L161.748 0.265625H158.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72356 0.265625H0V18.7748H2.72356V0.265625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4124 4.96987C9.4124 9.23924 4.71133 9.50001 3.98573 9.52557C4.77265 9.51534 10.0767 9.52557 10.0767 14.0711C10.0767 18.6165 4.09304 18.775 3.8171 18.775H5.79973C11.3439 18.775 12.9433 16.5969 12.9433 14.0046C12.9433 11.7497 11.4308 9.94484 7.47577 9.48978C10.465 8.94269 12.1411 7.19915 12.1411 5.04145C12.1411 2.44914 10.1789 0.270996 5.79973 0.270996H3.80688C4.76243 0.455065 9.40729 0.664699 9.40729 4.97498L9.4124 4.96987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.679 18.7748L104.578 0.265625H101.405L113.505 18.7748H116.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.952 18.7746H106.351C103.613 16.8676 101.952 9.52051 101.952 9.52051V18.7746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.157 9.51976V0.265625H111.758C114.497 2.17269 116.157 9.51976 116.157 9.51976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.049 18.0586V9.51514H129.709C129.709 9.51514 132.458 10.369 132.458 13.1861V18.0842C132.872 17.9819 134.338 17.6751 135.049 18.0586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.715 18.5858C125.749 18.9029 122.427 15.6765 122.427 9.30571C122.427 4.54548 123.792 1.00215 127.859 0C122.867 0 119.239 4.17734 119.239 9.51534C119.239 16.3872 124.824 20.3294 130.715 18.5858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.936 3.90105V0.265865C133.878 0.281203 131.303 0.173835 130.102 0C130.102 0 133.648 0.920301 134.936 3.90105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.186 14.9609V18.6728L73.2908 18.9336C70.2249 17.9979 68.9525 15.9375 68.186 14.9609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0562 3.96757V0.368174C79.0342 0.383512 76.5457 0.281256 75.3857 0.107422C75.3857 0.107422 78.4057 0.797647 80.0562 3.96757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5058 3.87598C70.5058 2.17846 71.63 0.81839 73.6433 0.112793C70.654 0.189488 68.2319 2.04552 68.2319 4.71452C68.2319 11.9699 78.6969 8.19649 78.6969 14.3628C78.6969 16.454 77.5728 18.1567 75.1507 18.939C78.5181 18.8623 81.0219 16.6125 81.0219 13.3709C81.0219 5.98255 70.5058 9.63325 70.5058 3.88109V3.87598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5723 4.28467L14.5835 18.7743H17.8794L20.5723 4.28467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0552 13.6004L27.8998 18.7748H30.7562L24.1492 0.265625H21.2928L25.3347 11.591L20.8687 12.5215L26.0552 13.6004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6101 4.28467L82.6213 18.7743H85.9172L88.6101 4.28467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.093 13.6004L95.9377 18.7748H98.7941L92.187 0.265625H89.3306L93.3725 11.591L88.9065 12.5215L94.093 13.6004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.596 0.265625L153.643 11.591L149.172 12.5215L154.359 13.6004L156.203 18.7748H159.06L152.453 0.265625H149.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.183 18.7743L148.876 4.28467L142.887 18.7743H146.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71 0.265625L194.757 11.591L190.286 12.5215L195.473 13.6004L197.317 18.7748H200.174L193.567 0.265625H190.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.297 18.7743L189.99 4.28467L184.001 18.7743H187.297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_6340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterMo);
export default __webpack_public_path__ + "static/media/LogoFooter__mo.7b4e841faa80ea99a3355a51bbaf57ec.svg";
export { ForwardRef as ReactComponent };